<template lang="pug">
  v-layout(row wrap)
    v-flex(xs12)
      Navbar(:backButtonPath="'back'")

      img.error-image(
        :src="errorPic"
        width="300px"
      )

      div.pt-5
       
        h3#error-msg(v-html="errorMessage")

        //- Wells Fargo Client Processing
        p#wf-client-processing-number.body-2.mt-3(v-if="lender === 'wellsfargo' && !isWellsFargoApplicant") Wells Fargo Client Processing
          PhoneLink(:phoneNumber="'(800)-551-5111'")

        //- Wells Fargo Customer Success
        p#wf-customer-number.body-2.ma-3(v-if="lender === 'wellsfargo' && isWellsFargoApplicant") Wells Fargo Customer Success
          PhoneLink(:phoneNumber="'(800) 869-3557'")
        
        //- Company Phone Number
        p#company-info.body-2.ma-3(v-if="companyPhoneNumber") {{ companyName }}
          PhoneLink(:phoneNumber="formatPhoneNumber(companyPhoneNumber)")
        
        //- OnCall Air Finance+ Phone Number
        p#c4c-phone-number.body-2.ma-3(v-if="!easyLinkErrorMessage") For more information, please contact us at 
          PhoneLink(:phoneNumber="'(786)-375-9482'")
        v-flex#WF-Result-actionSection-dealer.xs12(v-if="lender === 'wellsfargo' && !isWellsFargoApplicant")
          AppNextButton(id='WF-Result-returnBtn' :buttonFunction="toApplicationHistory") Return to Application History
</template>

<script>
import Navbar from 'Components/Navbar.vue'
import PhoneLink from 'Components/PhoneLink.vue'
import { mapState } from 'vuex'
import AppNextButton from 'Components/AppNextButton.vue'

export default {
  data() {
    return {
      errorPic: require('Assets/empty-desert.png'),
    }
  },
  components: {
    Navbar,
    PhoneLink,
    AppNextButton
  },
  computed: {
    ...mapState({
      companyName: state => state.user.companyName,
      companyPhoneNumber: state => state.user.companyPhoneNumber,
      isWellsFargoApplicant: state => state.user.isWellsFargoApplicant,
      lender: state => state.loanApplication.lender.id,
    }),
    errorMessage() {
      return this.$store.state.error.message || this.$store.state.errorMessage
    },
    easyLinkErrorMessage(){
      return this.errorMessage.includes('Easy Link')
    },
  },
  methods: {
    formatPhoneNumber(number) {
      const n = number.match(/^(\d{3})(\d{3})(\d{4})$/);
      return '(' + n[1] + ') ' + n[2] + '-' + n[3];
    },
    toApplicationHistory () {
      this.$router.push({
        path: '/application-history'
      })
    },
  }
}
</script>

<style lang="scss" scoped>
  .error-image {
    margin-top: 150px;
  }
  #error-msg {
    width: 60%;
    margin: auto;
  }
</style>